import { Currency } from '@sequencehq/api'
import {
  IconPlus,
  IndigoIndigo60,
  Primary13SemiBold,
  SimpleTableInput,
  Flex
} from '@sequencehq/core-components'
import { FC } from 'react'
import { PriceEditorPercentageTier } from 'common/drawers/PricingEditor/domain'
import { ValidationError } from '@sequencehq/utils'
import { usePercentageTierTableInput } from './usePercentageTierTableInput'

type PercentageTierTableInputProps = {
  onChange: (value: PriceEditorPercentageTier[]) => void
  value: PriceEditorPercentageTier[]
  isDisabled: boolean
  currency: Currency
  validationErrors: ValidationError[]
}

export const PercentageTierTableInput: FC<
  PercentageTierTableInputProps
> = props => {
  const { fieldConfig, addNewTier } = usePercentageTierTableInput(props)

  return (
    <>
      <SimpleTableInput
        {...fieldConfig}
        data-testid="priceEditor.percentageTiers"
      />
      <Flex justifyContent="center" marginTop="8px">
        <Flex
          {...Primary13SemiBold}
          width="fit-content"
          color={IndigoIndigo60}
          onClick={() => addNewTier()}
          _hover={{ opacity: 0.7 }}
          cursor="pointer"
          padding="4px 0"
          alignItems="center"
          data-testid="priceEditor.percentageTiers.addTier"
          gap="4px"
        >
          <IconPlus /> Add another tier
        </Flex>
      </Flex>
    </>
  )
}
